import { EnumeratorInterface } from "api/enumerator/Profile/dto";
import { Dayjs } from "dayjs";

export enum APPLICATION_STATUS {
  SUBMITTED = "SUBMITTED",
  PENDING = "PENDING",
  ON_VIEW = "ON_VIEW",
  SHORT_LISTED = "SHORT_LISTED",
}

export enum JobTypeValues {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME",
  CONTRACT = "CONTRACT",
  INTERNSHIP = "INTERNSHIP",
}

export enum JOB_STATUS {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  FILLED = "FILLED",
  EXPIRED = "EXPIRED",
}

export interface Salary {
  amount: number;
  period: string;
  isNegotiated: boolean;
  isPubliclyAvailable: boolean;
  currency: string;
}
export interface JobInterface {
  id: string;
  jobTitle: string;
  jobDescription: string;
  companyName?: string;
  recruiter?: string;
  salary: Salary;
  isSkillPubliclyAvailable: boolean;
  deadlineAt: Dayjs;
  jobType: string;
  experience: string[];
  totalNumberOfPeopleApplied: number;
  isPublished: boolean;
  isHotJob?: boolean;
  publishedAt: Date;
  publishedBy: string;
  status:JOB_STATUS;
  createdAt: Date;
  numberOfApplicants?: number;
  applicant?: any;
  numberOfVacancy: number[];
  skills: string[];
  joblocation: JobLocation[];
  questions?: JobQuestion[];
  
}

export enum JobApplicationActionType {
  APPLIED = "applied",
  SAVE = "save",
}
export interface JobLocation {
  district: string;
  province?: string;
  languages?: string[];
}

export interface JobApplyInterface {
  resume?: string;
  applicant_info?: EnumeratorInterface;
  coverLetter?: string;
  status?: string;
  questionAnswers?: Record<string, string | boolean>;
  isSaved?: boolean;
  appliedAt?: Date | string;
  appliedBy?: string;
}

export interface ApplyJobPayloadInterface {
  data: JobApplyInterface;
  id: string;
  enumerator_info: EnumeratorInterface;
}
export type PartialJobInterface = Partial<JobInterface>;

export interface UpdateJobPayloadInterface {
  id: string;
  job: PartialJobInterface;
}
export interface ApplicationPayloadInterface {
  applicant_info: EnumeratorInterface;
  jobId: string;
  status: string;
}

export interface UpdateJobApplicationPayload {
  id: string;
  payload: {
    applicant_info: EnumeratorInterface;
    status: string;
  };
}

export interface GetRecruiterJobsInterface {
  data: JobInterface[] | [];
  page: number;
  pageSize: number;
  totalData: number;
  isLastPage: boolean;
}

export interface GetJobsInterface {
  data: JobInterface[] | [];
  page: number;
  pageSize: number;
  totalData: number;
  isLastPage: boolean;
}

export type QuestionFieldType = 'boolean' | 'string';

export interface JobQuestion {
  id?: string;
  question: string;
  type: QuestionFieldType;
  isOptional: boolean;
 }
